import { WebStorageStateStore } from "oidc-client-ts";

export interface AppConfig {
  portalUrl: string;
  apiAuthority: string;
  apiClientId: string;
  apiUrl: string;
  licenseMui: string;
}

const config: AppConfig = {
  portalUrl: import.meta.env.VITE_PORTAL_URL || "",
  apiAuthority: import.meta.env.VITE_MSAL_AUTHORITY || "",
  apiClientId: import.meta.env.VITE_MSAL_CLIENT_ID || "",
  apiUrl: import.meta.env.VITE_API_URL || "",
  licenseMui: import.meta.env.LICENSE_MUI || "",
};

const buildRedirectUri = () => {
  const base = import.meta.env.VITE_PORTAL_URL || "";
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const oidcParams = new Set(["code", "state", "session_state", "iss", "error", "error_description"]);
  Array.from(params.keys()).forEach((k) => {
    if (oidcParams.has(k)) params.delete(k);
  });
  const qs = params.toString();
  return `${base}${url.pathname}${qs ? `?${qs}` : ""}`;
};

export const oidcConfig = {
  authority: import.meta.env.VITE_MSAL_AUTHORITY,
  client_id: import.meta.env.VITE_MSAL_CLIENT_ID,
  redirect_uri: buildRedirectUri(),
  silent_redirect_uri: `${import.meta.env.VITE_PORTAL_URL}/silent-renew.html`,
  automaticSilentRenew: true,
  scope: "openid profile email offline_access",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export default config;
